import { Controller } from "@hotwired/stimulus"
import { Sortable } from "sortablejs"
import { confirmDialog } from "../turbo_confirm"

// Einstellungen → Task-Status: drag a status within its category lane to reorder it, or into
// another lane to change its category. One Sortable per lane, sharing a group — the lanes
// are siblings, never nested. The server answers with the whole panel (TaskStatusesController
// #arrange), which replaces this element; a refusal comes back the same way, so the panel
// always shows what is stored.
export default class extends Controller {
  static targets = ["lane"]
  static values = { url: String, confirmTemplate: String }

  laneTargetConnected(lane) {
    lane.sortable = new Sortable(lane, {
      group: "task-statuses",
      draggable: "li[data-id]",
      handle: "[data-status-lanes-handle]",
      animation: 150,
      ghostClass: "opacity-40",
      // System statuses keep their category: they may only move within their own lane.
      onMove: (event) => event.dragged.dataset.locked !== "true" || event.to === event.from,
      onEnd: (event) => this.moved(event),
    })
  }

  laneTargetDisconnected(lane) {
    lane.sortable?.destroy()
  }

  async moved(event) {
    if (event.from === event.to && event.oldIndex === event.newIndex) return

    const item = event.item
    const taskCount = Number(item.dataset.taskCount || 0)
    if (
      event.from !== event.to &&
      taskCount > 0 &&
      !(await this.confirmCategoryChange(item, event.to))
    ) {
      event.from.insertBefore(item, event.from.children[event.oldIndex] || null)
      return
    }
    this.save()
  }

  confirmCategoryChange(item, lane) {
    const message = this.confirmTemplateValue
      .replace("__NAME__", () => item.dataset.name)
      .replace("__CATEGORY__", () => lane.dataset.categoryLabel)
      .replace("__TASKS__", () => item.dataset.taskCountLabel)
    return confirmDialog(message)
  }

  async save() {
    const body = new FormData()
    this.laneTargets.forEach((lane) => {
      lane.querySelectorAll("li[data-id]").forEach((item) => {
        body.append(`lanes[${lane.dataset.category}][]`, item.dataset.id)
      })
    })
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: { Accept: "text/vnd.turbo-stream.html", "X-CSRF-Token": token },
      body,
    })
    Turbo.renderStreamMessage(await response.text())
  }
}
